import * as Sentry from '@sentry/react';

export interface ErrorContext {
  phase: string;
  accountId?: string;
  accountName?: string;
  batchId?: string;
}

export function reportError(err: unknown, ctx: ErrorContext): void {
  Sentry.withScope(scope => {
    scope.setTag('phase', ctx.phase);
    if (ctx.accountId) scope.setTag('account_id', ctx.accountId);
    if (ctx.accountName) scope.setTag('account_name', ctx.accountName);
    if (ctx.batchId) scope.setContext('publish', { batchId: ctx.batchId });
    Sentry.captureException(err);
  });
}
